import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetCrmSyncIterationsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.IterationDocumentFilterInput>;
  first: Types.Scalars['Int']['input'];
  order?: Types.InputMaybe<Array<Types.IterationDocumentSortInput> | Types.IterationDocumentSortInput>;
}>;


export type GetCrmSyncIterationsQuery = { __typename?: 'Query', synchronizationIterations?: { __typename?: 'SynchronizationIterationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'IterationDocument', id: string, start: Types.TDateISO, end: Types.TDateISO, description: string, totalMs: number, itemsProcessed: number, success: boolean, error: string, skippedItems: Array<{ __typename?: 'IterationItem', key: string, value: string, reason: string, description: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };


export const GetCrmSyncIterationsDocument = new TypedDocumentString(`
    query GetCrmSyncIterations($where: IterationDocumentFilterInput, $first: Int!, $order: [IterationDocumentSortInput!]) {
  synchronizationIterations(where: $where, first: $first, order: $order) {
    nodes {
      id
      start
      end
      description
      totalMs
      itemsProcessed
      success
      error
      skippedItems {
        ...IterationItem
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment IterationItem on IterationItem {
  key
  value
  reason
  description
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCrmSyncIterations: build.query<GetCrmSyncIterationsQuery, GetCrmSyncIterationsQueryVariables>({
      query: (variables) => ({ document: GetCrmSyncIterationsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCrmSyncIterationsQuery, useLazyGetCrmSyncIterationsQuery } = injectedRtkApi;
